import axios from "axios";
import Cookies from "js-cookie";
import store from "@/store";
import router from "@/router";

const BASE_URL = process.env.VUE_APP_API_PROD_URL;

const http = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

http.interceptors.request.use((config) => {
  const currentLanguage = Cookies.get("zk_lng") || "ru";
  const token = Cookies.get("authToken");

  config.baseURL = `${BASE_URL}/${currentLanguage}`;

  if (token) {
    config.headers["X-Auth"] = `Bearer ${token}`;
  }

  return config;
});

http.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;

    if (response?.status === 401) {
      console.warn("Токен недействителен или истёк");

      store.commit("auth/LOGOUT");
      router.push("/login");
    }

    return Promise.reject(error);
  }
);

export default http;
